import React, { useState } from "react";
import { useEmployees } from "../../hooks/useEmployees";
import EmployeeTable from "./EmployeeTable";
import EmployeeFormModal from "./EmployeeFormModal";
import LoadingSpinner from "../../../../Component/Shared/LoadingSpinner/LoadingSpinner";
import ConfirmModal from "../../../../Component/Shared/ConfirmModal/ConfirmModal";
import styles from "./EmployeesTab.module.css";

const EmployeesTab = () => {
  const { employees, loading, error, addEmployee, updateEmployee, removeEmployee } = useEmployees();
  const [modalOpen, setModalOpen] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const openAddModal = () => { setEditingEmployee(null); setModalOpen(true); };
  const openEditModal = (employee) => { setEditingEmployee(employee); setModalOpen(true); };

  const handleSubmit = async (formData) => {
    if (editingEmployee) await updateEmployee(editingEmployee.id, formData);
    else await addEmployee(formData);
    setModalOpen(false);
  };

  const handleDeleteConfirm = async () => {
    setDeleting(true);
    await removeEmployee(deleteTarget.id);
    setDeleting(false);
    setDeleteTarget(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <h2>قائمة الموظفين</h2>
        <button className={styles.addBtn} onClick={openAddModal}>+ إضافة موظف</button>
      </div>

      {error && <div className={styles.error}>{error}</div>}

      {loading ? (
        <LoadingSpinner text="جاري تحميل الموظفين..." />
      ) : (
        <EmployeeTable employees={employees} onEdit={openEditModal} onDelete={setDeleteTarget} />
      )}

      {modalOpen && (
        <EmployeeFormModal
          initialData={editingEmployee}
          onSubmit={handleSubmit}
          onClose={() => setModalOpen(false)}
        />
      )}

      <ConfirmModal
        open={!!deleteTarget}
        title="حذف موظف"
        message={`هل أنت متأكد من حذف "${deleteTarget?.fullName}"؟`}
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteTarget(null)}
        loading={deleting}
      />
    </div>
  );
};

export default EmployeesTab;